// extracted by mini-css-extract-plugin
export default {"headDiv":"Users_headDiv__i6vDz","deactiveBtn":"Users_deactiveBtn__cBWxo","activeBtn":"Users_activeBtn__G0Rm8"};